"use strict"

import {observable, action} from "mobx"

class AddEmployeeDialog {
	@observable isOpen = false

	@action open() {
		this.isOpen = true
	}

	@action close() {
		this.isOpen = false
	}
}

var singleton = new AddEmployeeDialog()
export default singleton
